import { type RecType } from '@/defs/rec'

export const parseGalleryDeckText = (recs: RecType[]) =>
  recs.flatMap(({ count, name, partnerRef }) => [
    `${count || 1} ${name}`,
    ...(partnerRef ? [`${count || 1} ${partnerRef.name}`] : []),
  ])
